module.exports = __webpack_public_path__ + "img/sub-banner2.21a3d669.jpg";